/* Muaazon carousel for native variant links/radios; no visible scrollbars. */
(()=>{'use strict';
const selector='[data-mz-variant-carousel]',trackKey='[data-mz-variant-track]';
const ro=typeof ResizeObserver==='function'?new ResizeObserver(es=>es.forEach(e=>sync(e.target.closest(selector)))):null;
function sync(root){
 if(!root||!root.isConnected)return;
 const track=root.querySelector(trackKey),prev=root.querySelector('[data-mz-variant-prev]'),next=root.querySelector('[data-mz-variant-next]');
 if(!track||!prev||!next)return;
 const max=Math.max(0,track.scrollWidth-track.clientWidth),active=max>2;
 root.classList.toggle('is-static',!active);
 prev.disabled=!active||track.scrollLeft<=2;
 next.disabled=!active||track.scrollLeft>=max-2;
}
function init(root){
 if(!root)return;
 if(root.dataset.mzCarouselReady==='true'){sync(root);return;}
 const track=root.querySelector(trackKey);if(!track)return;
 root.dataset.mzCarouselReady='true';
 ro?.observe(track);
 track.addEventListener('scroll',()=>sync(root),{passive:true});
 const selected=track.querySelector('[aria-current="true"],input:checked');
 if(selected){
   const tile=selected.closest('.variant-option,.product-card__swatch')||selected;
   const tileBox=tile.getBoundingClientRect(),box=track.getBoundingClientRect();
   if(tileBox.right>box.right-4)track.scrollLeft+=tileBox.right-box.right+8;
   else if(tileBox.left<box.left+4)track.scrollLeft-=box.left-tileBox.left+8;
 }
 sync(root);
}
function scan(node){if(node.matches?.(selector))init(node);node.querySelectorAll?.(selector).forEach(init)}
document.addEventListener('click',e=>{
 const b=e.target.closest?.('[data-mz-variant-prev],[data-mz-variant-next]');
 if(!b||b.disabled)return;
 const root=b.closest(selector);init(root);
 const track=root.querySelector(trackKey);
 const max=Math.max(0,track.scrollWidth-track.clientWidth),at=track.scrollLeft;
 const tiles=Array.from(track.children).filter(n=>n.matches?.('.variant-option,.product-card__swatch'));
 const forward=b.hasAttribute('data-mz-variant-next'),box=track.getBoundingClientRect();
 const tile=forward
   ? tiles.find(n=>n.getBoundingClientRect().right>box.right+3)
   : tiles.slice().reverse().find(n=>n.getBoundingClientRect().left<box.left-3);
 const raw=tile?(tile.getBoundingClientRect().left-box.left+at-5):(forward?max:0);
 track.scrollTo({left:Math.max(0,Math.min(max,raw)),behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
});
document.addEventListener('focusin',e=>{const root=e.target.closest?.(selector);if(root)init(root)});
document.addEventListener('change',e=>{
 if(!e.target.matches?.('[data-variant-option-input]'))return;
 const root=e.target.closest(selector);if(!root)return;
 init(root);
 const track=root.querySelector(trackKey),tile=e.target.closest('.variant-option');
 if(track&&tile){
   const box=track.getBoundingClientRect(),item=tile.getBoundingClientRect();
   if(item.right>box.right-5)track.scrollLeft+=item.right-box.right+9;
   else if(item.left<box.left+5)track.scrollLeft-=box.left-item.left+9;
 }
 sync(root);
});
const run=()=>{
 scan(document);
 window.addEventListener('resize',()=>document.querySelectorAll(selector).forEach(sync),{passive:true});
 if(typeof MutationObserver==='function'&&document.body)new MutationObserver(records=>{
 for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1)scan(node);
 }).observe(document.body,{childList:true,subtree:true});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
})();
